<template>
  <li class="cm-s-wizer-light">
    <div :class="{ isInode: isInode, 'cm-tag': isInode }" @click="toggle">
      {{ item.label }}
      <span v-if="isInode">[{{ isOpen ? '-' : '+' }}]</span>
    </div>
    <ul v-show="isOpen" v-if="isInode">
      <tree-item
        class="item"
        v-for="(child, index) in item.children"
        :key="index"
        :item="child"
      ></tree-item>
    </ul>
  </li>
</template>

<script>
export default {
  name: 'TreeItem',
  props: {
    item: Object,
  },
  data() {
    return {
      isOpen: true,
    }
  },
  computed: {
    isInode() {
      return this.item.children && this.item.children.length
    },
  },
  methods: {
    toggle() {
      if (this.isInode) {
        this.isOpen = !this.isOpen
      }
    },
  },
}
</script>

<style scoped>
.isInode {
  font-weight: bold;
  cursor: pointer;
}
ul {
  margin-left: 1em;
  padding: 1px;
  line-height: 1.5em;
}
</style>
